import type { Project } from "@/data/projects";

export function ProjectVisual({ project }: { project: Project }) {
  return (
    <div className="relative flex h-full w-full flex-col items-center justify-center overflow-hidden" role="img" aria-label={`${project.title} workflow diagram`}>
      <div className="bg-grid absolute inset-0 opacity-60" aria-hidden="true" />
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(55% 55% at 50% 45%, var(--accent-muted), transparent 75%)", opacity: 0.25 }}
        aria-hidden="true"
      />
      <div className="relative flex flex-col items-center">
        {project.flow.map((step, i) => (
          <div key={step} className="flex flex-col items-center">
            {i > 0 && <span className="flow-connector" style={{ animationDelay: `${i * 0.25}s` }} aria-hidden="true" />}
            <div className="flow-node border border-line bg-background/85 px-6 py-3" style={{ animationDelay: `${i * 0.6}s` }}>
              <span className="font-mono text-[11px] tracking-[0.3em] md:text-xs">
                <span className="mr-3 text-accent">{String(i + 1).padStart(2, "0")}</span>
                {step}
              </span>
            </div>
          </div>
        ))}
      </div>
      <p className="absolute bottom-4 right-5 font-mono text-[9px] tracking-[0.3em] text-muted">{project.tagline}</p>
    </div>
  );
}
